/* eslint-disable react/prop-types */
import { Center, Modal, ModalBody, ModalContent, ModalOverlay, Spinner, Text } from '@chakra-ui/react';

const ModalLoading = ({ loading = false }) => {
    return (
        <Modal isOpen={loading} isCentered>
            <ModalOverlay />
            <ModalContent bg='transparent' boxShadow='none'>
                <ModalBody m='10'>
                    <Center flexDirection='column' gap={3}>
                        <Spinner size='xl' thickness='4px' color='primary.500' emptyColor='white' />
                        <Text textAlign='center' color='white'>
                            Please wait...
                        </Text>
                    </Center>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ModalLoading;
